import styled from 'styled-components';
import { Colors } from 'web-common/src/shared/Constants';

export const CheckoutIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.WHITE};
`;

export const CartItem = styled.div<{ unavailable?: boolean; isSoldOut?: boolean }>`
  padding: 0;
  margin: 8px 0;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 15px;

  ${({ unavailable, isSoldOut }) => (unavailable || isSoldOut) && `background-color: ${Colors.GRAY_LITE_30};`}
`;

export const Line = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  margin-bottom: -10px;

  &:first-child {
    margin-top: 4px;
  }
`;
